import Icon from "@components/ui/icon";
import { toast } from "react-toastify";

interface IProps {
  title?: string;
  details?: string;
}

export const sendMediaLibUploadErrorToast = ({
  title = "Upload failed",
  details,
}: IProps = {}) => {
  return toast.error(
    <div className="tw-flex tw-flex-col tw-text-left">
      <span>{title}</span>
      {details && <span className="tw-font-normal">{details}</span>}
    </div>,
    {
      autoClose: 5000,
      icon: (
        <Icon
          icon="ri-error-warning-fill"
          className="tw-text-[16px]/none tw-text-white"
        />
      ),
      className: "images-panel-clickable",
    },
  );
};
